const authReducer = (
  state = {
    loading: false,
    data: {
      accessToken: null,
      uid: null,
      email: null
    },
    credentials: {
      verificationId: null,
      authCredential: null
    },
    transaction: null,
    accountInfo: null,
    theme: {
      primaryColor: "#0E0E0E",
      secondaryColor: "#6EB3F4",
      secondaryColor1: "#18232E",
      tertiaryColor: "#FFFFFF",
      tertiaryColor1: "#1C1C1C",
      tertiaryColor2: "#262626",
      tertiaryColor3: "#353535",
      tertiaryColor4: "#3E3E3E",
      tertiaryColor5: "#6E6E6E",
      tertiaryColor6: "#CFCFCF",
      tertiaryColor7: "#ECECEC",
      tertiaryColor8: "#212121"
    }
  },
  action
) => {
  switch (action.type) {
    case "SET_AUTH_LOADING":
      return {
        ...state,
        loading: action.payload.loading
      };

    case "SET_AUTH_INFO":
      return {
        ...state,
        data: action.payload
      };

    case "SET_AUTH_VERIFICATION_ID":
      return {
        ...state,
        credentials: {
          ...state.credentials,
          verificationId: action.payload.verificationId
        }
      };

    case "SET_ACCESS_TOKEN":
      return {
        ...state,
        data: {
          ...state.data,
          accessToken: action.payload.accessToken
        }
      };
    case "SET_ACCOUNT_INFO":
      return {
        ...state,
        accountInfo: action.payload
      };
    case "SET_TRANSACTION":
      return {
        ...state,
        transaction: action.payload
      };
    case "RESET_TRANSACTION":
      return {
        ...state,
        transaction: null,
        accountInfo: null
      };

    case "SET_AUTH_CREDENTIALS":
      return {
        ...state,
        credentials: {
          ...state.credentials,
          authCredential: action.payload.authCredential
        }
      };

    case "CLEAR_AUTH_CREDENTIALS":
      return {
        ...state,
        credentials: {
          verificationId: null,
          authCredential: null
        }
      };

    case "PUT_THEME":
      return {
        ...state,
        theme: action.payload.theme
      };

    case "RESET":
      return state;

    default:
      return state;
  }
};
export default authReducer;
